import React, { Component } from "react";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { CalculateColors } from '../../helpers/ThemeColors'
import { NotificationManager } from "../../components/common/react-notifications";
import { Formik, Form, Field } from "formik";
import cookie from 'react-cookies'; 
import { loginUser, getCompany } from "../../redux/actions";
import { Colxx } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { dev } from "../../constants/defaultValues";
import './styles.css';
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      email: "",
      password: "",
      companyCode: false
    };
    /*
     email: "kawonr@aol.com",
      password: "Diwoc9E",
       email: "Tom Ronan",
      password: "6gbdXBKW",
      email: "kawonr@aol.com",
      password: "Diwoc9E",
      */
  }

  static getDerivedStateFromProps(props, state) {
    var ret = {};
      return ret;
  }

  componentDidMount(){
   
  }




  componentDidUpdate() {
   
  }

  render() {
   
   
    return (
      <Row className="h-100">
        <Colxx xxs="12">
          <Row className="Align-parent">
            <div className="col- Aligner" >
            <div className="Aligner-item Aligner1 loginLogoText">
              Simpli<span className="logoAd">Ad.</span>
              </div>
           </div>
          
         
          </Row>
         

          <Row>
            <Colxx xss="12" className="para-text">
            <div className="downtime-message">SimpliAd is performing a data collection process and will be back online quickly. Try again in 30 minutes.</div>

                
            </Colxx>
          </Row>


          <Row>
            <Colxx xss="12">
           
            </Colxx>
          </Row>

        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const {  } = authUser;
  
  return {  };
};

export default connect(
  mapStateToProps,
  {
  
  }
)(Login);
